import React from 'react';
import { Link } from 'react-router-dom';

const Greeting = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-[#f8f9fa] py-20 px-4">
      <div className="max-w-md w-full bg-white p-8 sm:p-12 rounded-[16px] border border-[#dadce0] shadow-sm text-center flex flex-col items-center">
        <div className="w-16 h-16 rounded-full bg-[#e6f4ea] flex items-center justify-center text-[#1e8e3e] mb-6 shadow-sm">
          <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
        <h2 className="text-2xl sm:text-3xl font-medium text-[#202124] tracking-tight mb-3">
          Thanks for Reaching Out!
        </h2>
        <p className="text-[15px] text-[#5f6368] leading-relaxed mb-8">
          We’ve received your message. One of our dedicated corporate guides will be in touch with you shortly.
        </p>
        <Link 
          to="/" 
          className="bg-[#1a73e8] hover:bg-[#1557b0] !text-white px-8 py-3 rounded-[4px] font-medium text-[15px] shadow-sm transition-colors !no-underline"
        >
          Return to Homepage
        </Link>
      </div>
    </div>
  );
};

export default Greeting;
